export default "__VITE_ASSET__aecf4885__"